import { render, staticRenderFns } from "./EditPatientAlert.vue?vue&type=template&id=9ff6db3e&"
import script from "./EditPatientAlert.vue?vue&type=script&lang=js&"
export * from "./EditPatientAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports